export const closeDialog = ({ setDeleteDialog }) => () => setDeleteDialog(false);
export const openDialog = ({ setDeleteDialog }) => () => setDeleteDialog(true);
